import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-47a1327d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block w-full mb-4" }
const _hoisted_2 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_3 = { class: "w-full flex gap-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "w-full helpText"
}
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "inputTitle" }
const _hoisted_10 = { class: "inputField flex-grow" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "inputTitle" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "popupSectionHeader w-full" }
const _hoisted_16 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "inputTitle" }
const _hoisted_19 = { class: "inputField flex-grow" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = { class: "mt-8 block w-full col-span-2" }
const _hoisted_22 = { class: "helpText mt-2 mb-2" }
const _hoisted_23 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_24 = { class: "flex justify-end" }
const _hoisted_25 = { class: "helpText mt-2 mb-2" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_27 = { class: "flex justify-end" }
const _hoisted_28 = { class: "w-full helpText" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "grid grid-cols-2 gap-4 w-full mt-4" }
const _hoisted_31 = { class: "inputTitle" }
const _hoisted_32 = { class: "inputField flex-grow" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = { class: "error-msg" }
const _hoisted_35 = { class: "inputTitle" }
const _hoisted_36 = { class: "inputField flex-grow" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "error-msg" }
const _hoisted_39 = { class: "inputTitle" }
const _hoisted_40 = { class: "inputField flex-grow" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = { class: "error-msg" }

import {computed, onBeforeUnmount, onMounted, reactive, Ref, ref, toRef} from "vue";
import {useI18n} from "vue-i18n";
import {useGlobalStore} from "@/stores/GlobalStore";
import useVuelidate from "@vuelidate/core";
import {email, helpers, required, requiredIf} from "@vuelidate/validators";
import {ErrorLocationType, FileStatus, ValidationStateType} from "@/utilities/enums/Enums";
import GridInputFilter from "@/components/GridInputFilter.vue";
import {BryntumGrid} from "@bryntum/grid-vue-3";
import {Grid, Store, StringHelper} from "@bryntum/grid";
import {checkboxColumnConfig} from "@/AppConfig";
import RecipientService from "@/utilities/services/entities/RecipientService";
import TabsWrapper from "@/components/tabs/TabsWrapper.vue";
import RecipientlistService from "@/utilities/services/entities/RecipientlistService";
import TabLayeredItem from "@/components/tabs/TabLayeredItem.vue";
import {useUploadSessionStore} from "@/stores/UploadSessionStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import CustomUploadProcessIndicator from "@/components/CustomUploadProcessIndicator.vue";
import NullOrUndefinedHelper from "@/utilities/helpers/NullOrUndefinedHelper";
import ProjectFile from "@/models/entities/ProjectFile";
import Recipient from "@/models/entities/Recipient";
import RecipientList from "@/models/entities/RecipientList";


export default /*#__PURE__*/_defineComponent({
  __name: 'FileEditPopup',
  props: {
  data: Object
},
  setup(__props) {

const {t} = useI18n();
const globalStore = useGlobalStore();
const props = __props
const popupData = toRef(props, 'data') as Ref<ProjectFile>;

const uploadSessionStore = useUploadSessionStore();
const activeTab = ref<number>(0);
const generateTicket = ref<boolean>(false);
const uploadInput = ref<HTMLInputElement|null>(null);
const isPartialUpload = computed(()=> uploadSessionStore.isPartialUpload);
const uploadPercentage = computed(() => uploadSessionStore.totalPercentage);
const validationState = computed(() => {
  const currentState = uploadSessionStore.validationState;
  if(currentState === ValidationStateType.invalid){
    ErrorHandler.showLocalError(t('general.error.hashing'), ErrorLocationType.popup);
  }
  return currentState
});
const recipientService = new RecipientService();
const recipientlistService = new RecipientlistService();

const rules = computed(() => {
  const hasNewRecipientData = () => {
    return !NullOrUndefinedHelper(popupData.value?.newRecipient?.firstName)
        || !NullOrUndefinedHelper(popupData.value?.newRecipient?.lastName)
        || !NullOrUndefinedHelper(popupData.value?.newRecipient?.email)
  }

  return {
    name: { required: helpers.withMessage(t('general.validation.required'), required) },
    newRecipient: {
      firstName: { required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)) },
      lastName: { required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)) },
      email: {
        required: helpers.withMessage(t('general.validation.required'), requiredIf(hasNewRecipientData)),
        email: helpers.withMessage(t('general.validation.email'), email)
      },
    },
  }
})
const v$ = ref(useVuelidate(rules, popupData.value));

const gridStore = new Store()
const grid = ref<{instance:{value:Grid}}|null>(null)
const useGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "360px",
  columns: [
    {
      id:'name',
      field: 'name',
      text: t('recipient.tabs.recipient.grid.name'),
      flex: 1,
      type: "template",
      template: ({record}:any) => {
        return StringHelper.xss`${record.firstName} ${record.lastName}`;
      }
    },
    {
      id: 'email',
      field : 'email',
      text: t('recipient.tabs.recipient.grid.email'),
      flex: 1,
      sortable: true
    },
  ],
  store: gridStore,
  listeners:{
    selectionChange(event:any) {
      popupData.value!.recipients = event.selection.map((sr:any) => sr.originalData as Recipient);
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const gridConfig = reactive(useGridConfig)

const listGridStore = new Store()
const listGrid = ref<{instance:{value:Grid}}|null>(null)
const useListGridConfig = {
  emptyText: t("general.noEntries"),
  headerMenuFeature: false,
  height: "360px",
  columns: [
    {
      id:'name',
      field: 'name',
      text: t('recipient.tabs.list.grid.name'),
      flex: 1,
    },
    {
      id:'recipientCount',
      field: 'recipientCount',
      text: t('recipient.tabs.list.grid.recipientCount'),
      flex: 1,
    },
  ],
  store: listGridStore,
  listeners:{
    selectionChange(event:any) {
      popupData.value!.recipientLists = event.selection.map((sr:any) => sr.originalData as RecipientList);
    },
  },
  enableTextSelection: true,
  selectionMode : {
    row	  : true,
    checkbox: checkboxColumnConfig,
    showCheckAll : true,
    deselectFilteredOutRecords: true
  }
}
const listGridConfig = reactive(useListGridConfig)

const toggleTicketCreation = () => {
  generateTicket.value = !generateTicket.value;
  if(!generateTicket.value) {
    popupData.value!.recipients = [];
    popupData.value!.recipientLists = [];
    popupData.value!.newRecipient = new Recipient();
    grid.value?.instance.value.deselectAll();
    listGrid.value?.instance.value.deselectAll();
  }
}

const uploadFileToBrowser = async () => {
  const uploadedFile = uploadInput.value?.files ? uploadInput.value?.files[0] as File : null;
  if (!uploadedFile) return;

  // dont set name or downloadName when file is already partially uploaded
  if(isPartialUpload.value) {
    popupData.value!.file = uploadedFile;
    return;
  }

  popupData.value!.name = uploadedFile.name;
  popupData.value!.sizeInBytes = uploadedFile.size;
  popupData.value!.type = uploadedFile.type !== "" ? uploadedFile.type : "application/octet-stream";
  popupData.value!.extension = `.${uploadedFile.name.split('.').pop()}`;
  popupData.value!.file = uploadedFile;
}

const setRecipientData = async ()=>{
  const resp = await recipientService.getForUser(ErrorLocationType.popup);
  if(!resp) return;

  gridStore.data = resp;
}

const setRecipientListData = async ()=>{
  const resp = await recipientlistService.getForUser(ErrorLocationType.popup);
  if(!resp) return;

  listGridStore.data = resp;
}

onMounted(async ()=> {
  globalStore.modal.validator = {$validate:v$.value.$validate};

  uploadSessionStore.validationState = ValidationStateType.none
  uploadSessionStore.totalPercentage = popupData.value?.status === FileStatus.completed
      ? "100%"
      : await uploadSessionStore.getTotalUploadPercentage(popupData.value?.downloadToken, ErrorLocationType.popup) ?? "0%";

  // reset popupData
  popupData.value!.recipients = [];
  popupData.value!.recipientLists = [];
  popupData.value!.newRecipient = new Recipient();
  popupData.value!.messageToRecipients = null;

  await setRecipientData();
  await setRecipientListData();
})

onBeforeUnmount(()=>{
  uploadSessionStore.uploadAbortController
      ? uploadSessionStore.uploadAbortController.abort()
      : null;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", {
          class: "w-[200px]",
          disabled: popupData.value.status === _unref(FileStatus).completed
        }, [
          _createElementVNode("input", {
            type: "file",
            accept: "*/*",
            multiple: false,
            ref_key: "uploadInput",
            ref: uploadInput,
            onChange: uploadFileToBrowser,
            style: {"display":"none"},
            disabled: popupData.value.status === _unref(FileStatus).completed
          }, null, 40, _hoisted_5),
          _createElementVNode("div", {
            class: "w-full flex justify-center items-center pseudoButton pseudoSecondary",
            disabled: popupData.value.status === _unref(FileStatus).completed
          }, _toDisplayString(_ctx.$t('dashboard.tabs.file.popups.edit.uploadButton')), 9, _hoisted_6)
        ], 8, _hoisted_4),
        _createVNode(CustomUploadProcessIndicator, {
          class: "flex-grow",
          percentage: uploadPercentage.value,
          validationState: validationState.value,
          knownFileName: popupData.value.name,
          uploadFileName: popupData.value.file?.name,
          fileSize: popupData.value.sizeInBytes
        }, null, 8, ["percentage", "validationState", "knownFileName", "uploadFileName", "fileSize"])
      ]),
      (isPartialUpload.value && popupData.value.status !== _unref(FileStatus).completed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('dashboard.tabs.file.popups.edit.helpText.upload')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.tabs.file.popups.edit.desc')), 1),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((popupData.value.description) = $event)),
            class: "w-full"
          }, null, 512), [
            [_vModelText, popupData.value.description]
          ]),
          _hoisted_11
        ])
      ]),
      (!_unref(NullOrUndefinedHelper)(popupData.value.messageToCreator))
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)("dashboard.tabs.file.grid.messageToCreator")), 1),
            _createElementVNode("textarea", {
              class: "w-full min-h-[80px]",
              value: popupData.value.messageToCreator,
              disabled: true
            }, null, 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("button", {
        onClick: toggleTicketCreation,
        class: "secondary mt-6"
      }, _toDisplayString(generateTicket.value ? _unref(t)('dashboard.tabs.file.popups.edit.dropTicket') : _unref(t)('dashboard.tabs.file.popups.edit.generateTicket')), 1),
      (generateTicket.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('dashboard.tabs.file.popups.edit.messageToRecipient')), 1),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((popupData.value.messageToRecipients) = $event)),
                    class: "w-full min-h-[80px]"
                  }, null, 512), [
                    [_vModelText, popupData.value.messageToRecipients]
                  ]),
                  _hoisted_20
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(TabsWrapper, { activeTab: activeTab.value }, {
                default: _withCtx(() => [
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.recipients')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('dashboard.tabs.file.popups.edit.helpText.recipients')), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createVNode(GridInputFilter, {
                            gridStore: _unref(gridStore),
                            hideFilterButton: true
                          }, null, 8, ["gridStore"])
                        ]),
                        _createVNode(_unref(BryntumGrid), _mergeProps({
                          ref_key: "grid",
                          ref: grid
                        }, gridConfig, { readOnly: true }), null, 16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.recipientlists')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(t)('dashboard.tabs.file.popups.edit.helpText.lists')), 1),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(GridInputFilter, {
                            gridStore: _unref(listGridStore),
                            hideFilterButton: true
                          }, null, 8, ["gridStore"])
                        ]),
                        _createVNode(_unref(BryntumGrid), _mergeProps({
                          ref_key: "listGrid",
                          ref: listGrid
                        }, listGridConfig, { readOnly: true }), null, 16)
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"]),
                  _createVNode(TabLayeredItem, {
                    title: _unref(t)('dashboard.tabs.file.popups.edit.newRecipientTabTitle')
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("span", {
                            innerHTML: _ctx.$t('dashboard.tabs.file.popups.edit.helpText.newRecipient')
                          }, null, 8, _hoisted_29)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.name')) + " * ", 1),
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.firstName.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((popupData.value.newRecipient.firstName) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.firstName]
                                ]),
                                _hoisted_33,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.firstName.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_34, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.lastName')) + " * ", 1),
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.lastName.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((popupData.value.newRecipient.lastName) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.lastName]
                                ]),
                                _hoisted_37,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.lastName.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_38, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('recipient.tabs.recipient.popups.edit.email')) + " * ", 1),
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("div", {
                                class: _normalizeClass({ error: v$.value.newRecipient.email.$errors.length })
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((popupData.value.newRecipient.email) = $event)),
                                  class: "w-full"
                                }, null, 512), [
                                  [_vModelText, popupData.value.newRecipient.email]
                                ]),
                                _hoisted_41,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v$.value.newRecipient.email.$errors, (error) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "input-errors",
                                    key: error.$uid
                                  }, [
                                    _createElementVNode("div", _hoisted_42, _toDisplayString(error.$message), 1)
                                  ]))
                                }), 128))
                              ], 2)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["title"])
                ]),
                _: 1
              }, 8, ["activeTab"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})